import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { useSSOToken } from '../../../hooks/usePaymentus';
import {
  IFrameInfoRequest,
  PaymentCategory,
  PaymentProfile,
} from '../../../__generated__/pge-types';
import { ProfileChangeHandler } from '../types';
import { getLanguage } from '../../../providers/LanguageProvider';
import { useInvoiceSSOToken } from '../../../hooks/invoice-payment-portal/usePaymentus';

type Props = {
  iframeProps: IFrameInfoRequest;
  onChange: ProfileChangeHandler;
  onNew: ProfileChangeHandler;
  onError?: (error: any) => any;
  buttonLabelText?: string;
  invoicePayment?: boolean;
};

const POST_MESSAGE_EVENT = 'message';

enum MESSAGE_TYPE {
  FrameHeight = 'frameHeight',
  PmDetails = 'pmDetails',
  Result = 'Result',
}

// SUCCESS MESSAGE =  pmDetails:{"Token":"FE2EF495A1152561572949784C16BF23ABB28057","Type":"VISA","MaskedAccountNumber":"************4448","CardHolderName":"Chetan Mehendale","ExpiryDate":"09/2022","Default":"false"}
// ERROR MESSAGE =  Result:{"ERROR:":["Unable to save profile: duplicate payment method"]}

const PaymentusIFrame = (props: Props) => {
  const [iframeHeight, setIframeHeight] = useState('100%');

  const { iframeProps, onChange, onError, onNew } = props;

  const [loaded, setLoaded] = useState(false);

  const onSuccessResult = (successData: any) => {
    console.log('onSuccessResult', successData);
    const {
      Token,
      Type,
      MaskedAccountNumber,
      CardHolderName,
      ExpiryDate,
      Default,
    } = successData;

    let profile: PaymentProfile = {
      token: Token,
      type: Type,
      accountNumber: MaskedAccountNumber,
      cardHolderName: CardHolderName,
      default: Default,
    };

    // no ExpiryDate for Bank Account, so need special handling
    if (ExpiryDate) {
      const [month, year] = ExpiryDate.split('/');

      profile = {
        ...profile,
        creditCardExpiryDate: {
          month,
          year,
        },
      };
    }

    iframeProps.token === Token ? onChange(profile) : onNew(profile);
  };

  const onErrorResult = (err: any) => {
    console.log('onErrorResult', err);
    if (onError) {
      onError(err);
    }
  };

  const getJsonValueForKey = (message: string, key: string) => {
    const idx = message.indexOf(key);
    if (idx >= 0) {
      const sub = message.substring(idx + key.length + 1);
      console.log('Message Key = ', key, ', Payload = ', sub);
      return JSON.parse(sub);
    }
    return {};
  };

  const postMessageHandler = (e: any) => {
    console.log('MESSAGE', e, e.data);
    const msgData = String(e.data || '');

    if (msgData.indexOf(MESSAGE_TYPE.FrameHeight) >= 0) {
      const [, height] = e.data.split(':');
      const newHeight = Number(height) + 60;
      if (newHeight + 'px' !== iframeHeight) {
        // HACK - force the iframe to scroll when the window height
        // is lesser than the calculated iframe height
        // The magic numbers 201 and 121 factor in the diffs between
        // parent Modal height and the iframe height for "edit" and "add"
        // respectively
        // TODO - maybe better to use a Dialog instead of Modal?
        if(iframeProps.pmCategory === PaymentCategory.Venmo){
          setIframeHeight((newHeight + 200) + 'px',
        );
        } else {
        setIframeHeight(
          Math.min(
            newHeight,
            window.innerHeight - (iframeProps.token ? 201 : 121),
          ) + 'px',
        );
      }
      }
      return;
    }

    if (msgData.indexOf(MESSAGE_TYPE.PmDetails) >= 0) {
      onSuccessResult(getJsonValueForKey(msgData, 'pmDetails'));
      return;
    }

    if (e.data && msgData.indexOf(MESSAGE_TYPE.Result) >= 0) {
      onErrorResult(getJsonValueForKey(msgData, 'Result'));
      return;
    }

    // console.log('WINDOW EVENT', e);
  };
  const { data, loading, error } = props?.invoicePayment ? useInvoiceSSOToken(iframeProps) : useSSOToken(iframeProps);
  
  useEffect(() => {
    window.addEventListener(POST_MESSAGE_EVENT, postMessageHandler);

    // this will clean up the event every time the component is re-rendered
    return () => {
      window.removeEventListener(POST_MESSAGE_EVENT, postMessageHandler);
    };
  });

  useEffect(() => {
    if (!loading) {
      const iframe: any = document.querySelector(
        `#iframe_${iframeProps.ownerId}_${iframeProps.pmCategory}`,
      );

      if (iframe) {
        iframe.onload = () => setLoaded(true);
      }
      // this will clean up the event every time the component is re-rendered
      return () => {
        if (iframe) {
          iframe.onload = null;
        }
      };
    }
  }, [loading]);
  const language = getLanguage();
  console.log('SRC', data?.getIFrameInfo?.src);
  const iframeSource =
  props.buttonLabelText && data?.getIFrameInfo?.src
      ? data?.getIFrameInfo?.src + `&lang=${language}&bnxtlbl=` + props.buttonLabelText
      : data?.getIFrameInfo?.src + `&lang=${language}`;

  console.log('iframeSource',iframeSource);

  return (
    <Grid
      item
      xs={12}
      style={{ flexDirection: 'column', display: 'flex', margin: '0' }}
    >
      {(loading || !loaded) && <CircularProgress></CircularProgress>}
      {data?.getIFrameInfo?.src && !loading && (
        <iframe
          id={`iframe_${iframeProps.ownerId}_${iframeProps.pmCategory}`}
          src={iframeSource}
          width={'100%'}          
          height={iframeHeight}
          allow="payment *"
          style={{ border: 'none', visibility: loaded ? 'visible' : 'hidden' }}
        />
      )}
    </Grid>
  );
};

export default PaymentusIFrame;
